// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeletedByMePayload__icon-c9af70 {
  margin-top: -1px;
  min-width: min-content;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/GroupDescription/LastMessageDescription/DeletedByMePayload/DeletedByMePayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sBAAA;AACF","sourcesContent":[".icon {\n  margin-top: -1px;\n  min-width: min-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `DeletedByMePayload__icon-c9af70`
};
module.exports = ___CSS_LOADER_EXPORT___;
